export default __webpack_public_path__ + "static/media/goldenrushBg.cfd9c8de.png";